exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-excel[data-v-c9dbca04]{position:fixed;top:-300px;left:0}.import-excel .input-file[data-v-c9dbca04]{position:fixed;top:-300px;left:0;width:100%;height:100%;display:none}\n", ""]);

// exports
